import ComingSoonPage from "../../components/ComingSoonPage";
import AppShell from '../../components/AppShell';

export default function FlowBuilder() {
  return (
    <AppShell>
      <div className="lg:col-span-8 space-y-6 text-center">
    <ComingSoonPage
      appName="Flow Builder AI"
      teaser="Automate business workflows with AI-generated visual flows."
      imageSrc="/images/coming-soon/trendpulse.png"
    />
    </div>
    </AppShell>
  );
}

